import { ChangeEventHandler, FocusEventHandler, forwardRef } from 'react';
import { StyledDateInput, StyledDateInputAlt } from './styled';

export interface DateInputProps {
  value?: string | number;
  min?: string | number;
  max?: string | number;
  defaultValue?: string | number;
  name?: string;
  required?: boolean;
  readOnly?: boolean;
  inputSize?: 'small' | 'medium' | 'big';
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  disabled?: boolean;
}

export const DateInput = forwardRef<HTMLInputElement, DateInputProps>(
  (
    {
      inputSize = 'medium',
      min,
      max,
      defaultValue,
      required = false,
      readOnly = false,
      value,
      onChange,
      onBlur,
      name,
      ...props
    },
    ref
  ): JSX.Element => {
    return (
      <StyledDateInput
        ref={ref}
        {...props}
        type="date"
        min={min}
        max={max}
        defaultValue={defaultValue}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        value={value}
        required={required}
        readOnly={readOnly}
        inputSize={inputSize}
      />
    );
  }
);

export const DateInputAlt = forwardRef<HTMLInputElement, DateInputProps>(
  (props, ref): JSX.Element => {
    return <StyledDateInputAlt type="date" ref={ref} {...props} />;
  }
);
